<template>
    <div class="top-banner_ext" />
</template>
<script>
export default {};
</script>
